import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '../../../../components'
import './filter.scss'
import FilterCiclo from './filterCiclo'
import FilterData from './filterData'
import { filterHandle, putFiltersProvisorio, setFiltersProvisorio } from '../redux/csatconcorrentesprodutosActions'

export default () => {
  const dispatch = useDispatch()
  const { projeto, empresa, filters, grupo, listas: {typeSearch}, ciclos, sistema } = useSelector(state=> state.layoutState)
  const { filtersProvisorio } = useSelector(state=> state.csatconcorrentesprodutosState)

  const nls = require(`../nls/${sistema.idioma}.json`)

  useEffect(()=> {
    let filtros = filters
    if (!filters?.ciclo?.anoMes  && ciclos.length) {
      //filtros = {...filtersProvisorio, ...filtros, ciclo: ciclos[ciclos.length - 1]}
      filtros = {...filtersProvisorio, ...filtros, ciclo: ciclos[0]}
    }
    dispatch(setFiltersProvisorio(filtros))
  }, [ciclos])


  const handleSearching = (params) => {
    handleSearchingValid(params)
  }
  
  const handleSearchingValid = (params) => {
    const labelgraf = {
        atual: nls.labelgrafico.atual,
        anterior: nls.labelgrafico.anterior
      };
      dispatch(filterHandle({projetoID: projeto.id, grupo, empresaId: empresa.empresaId, params, filtersProvisorio, typeSelect: params.typeSelect, idioma: sistema.idiomaIdValue, labelgraf}))
  }
  
  const contentFilterType = (e) => {
    switch (e?.id) {
      case 'Ciclo':
        return <FilterCiclo />;
      case 'Data':
        return <FilterData />;
      default:
        return;
    }
  }
  
  return (
    <div className='box-csatconcorrentesprodutos-search box-content'>
      <div className='box-csatconcorrentesprodutos-search-box'>
        <div className='box-csatconcorrentesprodutos-search-type'>
          {
            typeSearch.map((type)=> {
              return <Button
                color={'primary'}
                type={type.id === filtersProvisorio?.typeSelect?.id?'btn':'link'}
                size='small'
                onClick={()=> dispatch(putFiltersProvisorio({name: 'typeSelect', value: type}))}
                key={type.id}
              >
                {type.label}
              </Button> 
            })
          }
          <p>{filtersProvisorio?.typeSelect?.text === 'Filtrar por Ciclo' ? nls.filtrarporciclo : nls.filtrarpordata}</p>
        </div>
        <div>
          {contentFilterType(filtersProvisorio?.typeSelect)}
        </div>

      </div>
      <div className='box-csatconcorrentesprodutos-search-action'>
        <Button
          color='primary'
          size='large'
          onClick={()=> handleSearching(filtersProvisorio)}
        >{nls.pesquisar}</Button>          
      </div>
    </div>
  )
}
